export const ADD_MD = 'mobileDetect/ADD_MD';
